// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nEyR","content":"styles_content__1y_OC","row":"styles_row__2QoqQ","footer":"styles_footer__NB5sV","phraseLength":"styles_phraseLength__3Hkx2"};